export default function filtrarRegistrosPorAsesor(registros, idAsesor) {
  return registros.filter(registro => registro.Broker_ID === idAsesor);
}